export default "__VITE_ASSET__DmLc_1_a__"